import styled from 'styled-components';

import { breakpoints } from '@r1-frontend/entities/Layout/Header/types';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Button = styled(BaseButton) <{ isBurgerOpen?: boolean }>`
    align-self: center;
    margin-left: 16px;
    width: 100%;
    cursor: pointer;
    margin-bottom: ${p => p.isBurgerOpen ? '12px' : '0'};
    max-width: ${p => p.isBurgerOpen ? 'auto' : '164px'};
    ${p => p.isBurgerOpen ? FONTS.MediumS : FONTS.MediumXS};

    @media (max-width: ${breakpoints.sDesktop}) {
        margin-left: 0;
    }

    @media (max-width: ${breakpoints.sMobile}) {
        max-width: ${p => p.isBurgerOpen ? 'auto' : '124px'};
    }
`;

export const ButtonsBlock = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    margin-top: 12px;
    margin-bottom: 12px;
    padding-left: 24px;
    padding-right: 24px;
`;

export const Login = styled.div`
    color: ${COLORS.TextPrimary};
    align-items: end;

    &:hover {
        color: ${COLORS.Logo};
    }

    @media (max-width: ${breakpoints.tablet}) {
        &:before {
            margin-bottom: 0;
        }
    }
`;
